<!-- Selected Group -->
<li class="dropdown-menu_item linking-group-list_row -selected"
  (click)="close()">

  <div class="linking-group-list_row_icon-container">
    @switch (selectedMenuItem?.value.id) {
      @case (WidgetLinkingGroupId.NONE) {
        <svg class="linking-group-list_row_icon-container_icon">
          <use xlink:href="#chain"></use>
        </svg>
      }
      @default {
        <div class="linking-group-list_row_icon-container_css-icon"
          ngClass="{{selectedMenuItem.value.className}}">
        </div>
      }
    }
  </div>

  <div class="linking-group-list_row_label">{{selectedMenuItem.label | l10n}}</div>
</li>

<li class="dropdown-menu_item linking-group-list_row -separator">
  <hr />
</li>

<!-- Group list -->
@for (menuItem of menuItems; track menuItem; let i = $index) {
  <li class="dropdown-menu_item linking-group-list_row"
    (click)="onMenuItemClick(menuItem)"
    [class.-hover]="i === preselectedMenuItemIndex"
    #item>
    <div class="linking-group-list_row_icon-container">
      @switch (menuItem.value.id) {
        @case (WidgetLinkingGroupId.NONE) {
          <svg class="linking-group-list_row_icon-container_icon">
            <use xlink:href="#chain"></use>
          </svg>
        }
        @default {
          <div class="linking-group-list_row_icon-container_css-icon"
            ngClass="{{menuItem.value.className}}">
          </div>
        }
      }
    </div>
    <div class="linking-group-list_row_label">{{menuItem.label | l10n}}</div>
  </li>
}
